import React from 'react';
import { PSPType } from '../../stores/types';
import Axis from '../../assets/img/axis.png';
import Cashfree from '../../assets/img/cashfree.png';

type PspPropsType = {
    pspType: PSPType,
    empty?: boolean,
}

const Psp: React.FC<PspPropsType> = ({ pspType, empty }) => {
    let pspIcon = null;
    if (pspType === "axis") pspIcon = Axis;
    else if (pspType === "cashfree") pspIcon = Cashfree;
    if (!pspIcon) return empty ? null : <span>-</span>;
    return (
        <img src={pspIcon} alt={pspType} className='w-4 h-4' />
    )
}

Psp.defaultProps = {
    empty: false,
}

export default Psp;